import styles from './Product.module.scss';
import { addCustomPathToLink, checkIsFavourite, toggleFavourite } from '../../functions';
import React, { useEffect, useState } from 'react';
import { ModalContext } from '../Modal/modalContext';
import ProductModal from '../ProductModal/ProductModal';
import ProductPrice from '../ProductModal/ProductPrice';

const Product = ({ product }) => {
  let { handleModal } = React.useContext(ModalContext);
  const [isFavourite, setIsFavourite] = useState(false);

  useEffect(() => {
    setIsFavourite(checkIsFavourite(product.id));

    const localStorageSetHandler = () => {
      setIsFavourite(checkIsFavourite(product.id));
    };

    document.addEventListener('itemInserted', localStorageSetHandler, false);
    return (_) => {
      document.removeEventListener('itemInserted', localStorageSetHandler, false);
    };
  }, []);

  const modifiedImagePath = addCustomPathToLink(product.images[0].src).replace(
    'width=1200&height=1200&format=jpg&quality=80;quality=80&amp;fit=bounds&amp;fit=bounds&amp;canvas=1200,1200',
    'width=450&height=450&format=jpg&quality=80;quality=80&amp;fit=bounds&amp;fit=bounds&amp;canvas=500,500'
  );

  return (
    !!product?.name && (
      <div className={styles.swiperProduct} onClick={() => handleModal(<ProductModal id={product.id} />)}>
        <div className={styles.mainImage}>
          <figure className={`${styles.imageBox} ${!!product?.activeBorder ? styles.borderActive : ''}`}>
            <img className={styles.image} src={modifiedImagePath} alt={product.images[0].alt} />
          </figure>
          <button
            className={`${styles.btnHeart} ${isFavourite ? styles.btnHeartFull : styles.btnHeartEmpty}`}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              toggleFavourite(product.id);
              setIsFavourite(!isFavourite);
            }}
          ></button>
        </div>
        <p className={styles.info}>{product.labels[0]}</p>
        <p className={styles.name}>{product.name}</p>
        <ProductPrice product={product} />
      </div>
    )
  );
};

export default Product;
